// Dependencies.
import { pushTrackingData } from '../../lib/dataLayer';
import DomComponent from '../../lib/domComponent';
import { mq } from '../../lib/util';

/**
 * The chat button/window shown at the bottom right of the page.
 */
export default class ChatComponent extends DomComponent {
    static selector = 'body';

    constructor(el) {
        super(el);

        this.initTracking(this.el);

        const module = el.querySelector('[data-js-module="chat"]');

        if (module) {
            // Variables.
            this.newWindowLink = module.dataset.chatbotUrl;
        }
    }

    initTracking(el) {
        const chatButtonSelector = '.satisfi_chat-button';
        let globalChatButton;

        el.addEventListener('click', (e) => {
            const { target } = e;
            const triggerButton = target.closest('[data-chat-button]');
            const chatButton = target.closest(chatButtonSelector);

            if (chatButton) {
                this.track();
            } else if (triggerButton) {
                globalChatButton = typeof(globalChatButton) !== 'undefined' ? globalChatButton : el.querySelector(chatButtonSelector);

                if (!globalChatButton) {
                    return;
                }

                e.preventDefault();
                globalChatButton.click();
            }
        })
    }


    track() {
        pushTrackingData({
            'name': 'start_chat'
        });
    }

}